// Hero generally gets to 600/700 max width so roughly doubled this
export const IMAGE_DIMENSION_HERO_SECTION_WIDTH = 1200;

// Slide generally gets to 600/700 max width so roughly doubled this
export const IMAGE_DIMENSION_SLIDES_SECTION_WIDTH = 1200;

// Potential max width of the site + some more to account for high dpi screens
export const IMAGE_DIMENSION_IMAGE_SECTION_MAX_WIDTH = 2000;

// Generally image is displayed around 370x300, hotspot (so we have width/height), doubled it
export const IMAGE_DIMENSION_SUCCESS_STORY_CARD_WIDTH = 740; // ~370 x 2
export const IMAGE_DIMENSION_SUCCESS_STORY_CARD_HEIGHT = 600; // ~300 x 2

export const IMAGE_DIMENSION_HERO_SECTION_LOGO_WIDTH = 200;

export const IMAGE_DIMENSION_TECH_SPEC_SECTION_IMAGE_WIDTH = 1200;

export const IMAGE_DIMENSION_TECH_SPEC_SECTION_MOBILE_IMAGE_WIDTH = 800;

// generic width for images that take up half a page section
export const IMAGE_DIMENSION_HALF_SECTION_WIDTH = 800;

export const IMAGE_DIMENSION_CONFIG_V2_GALLERY = 800;
